const buyLink = {
  computed: {
    cardLinkUrl() {
      if (this.$i18n.locale === 'zh') {
        return 'https://shop95838799.m.youzan.com/wscgoods/detail/3nlty4s43wymfg0';
      } else {
        return 'https://www.keypal.store/products/keypal-backup-card';
      }
    },
  },
  methods: {
    goBuyKeyPalCard() {
      window.open(this.cardLinkUrl);
    },
  },
};

export default buyLink;
